import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classname';
import './upload-image.less';

import withIntl, { IntlPropType } from '../../intl-hoc';

function UploadImage({ intl, className, title, input, meta, disabled }) {
	const isValue = !!input.value;

	function handleChange(e) {
		const file = e.target.files[0];

		if (file) {
			input.onChange({ file, blob: URL.createObjectURL(file) });
			e.target.value = ''; // reset the field value for correct deletion
		}
	}

	function handleRemove() {
		input.onChange(null);
	}

	return (
		<div className={cn('upload-image', className)}>
			<div className='upload-image--block'>
				{isValue && (
					<img
						className='upload-image--image'
						src={input.value.blob}
						alt='upload image file'
					/>
				)}
				<label className={cn('upload-image--label', {
					'upload-image--label-enabled': !disabled,
					'upload-image--label-present': isValue
				})}>
					<span className='upload-image--title'>
						{!disabled && intl(isValue ? 'change' : 'upload')} {title}
					</span>
					<input
						className='upload-image--input'
						type='file'
						accept='image/*'
						disabled={disabled}
						onChange={handleChange}
					/>
				</label>
				{(isValue && !disabled) && (
					<div
						className='upload-image--reset'
						onClick={handleRemove}
					>
						×
					</div>
				)}
			</div>
			{(meta.touched && meta.error) && (
				<div className='upload-image--error'>{meta.error}</div>
			)}
		</div>
	);
}

UploadImage.propTypes = {
	intl: IntlPropType,
	className: PropTypes.string,
	title: PropTypes.string,
	input: PropTypes.shape({
		value: PropTypes.exact({
			blob: PropTypes.string,
			file: PropTypes.object
		}),
		onChange: PropTypes.func.isRequired
	}).isRequired,
	meta: PropTypes.shape({
		touched: PropTypes.bool.isRequired,
		error: PropTypes.string
	}).isRequired,
	disabled: PropTypes.bool
};

export default withIntl(UploadImage);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/new-upload/upload-image.js